<template>
  <div class="card border-0 radius-bottom-0" v-if="legal_person">
    <div class="card-header bg-dark text-white row m-0 pt-4 pb-4">
      <div class="col-10">
        <h4 class="card-tite d-flex align-items-center">
          <font-awesome-icon icon="landmark" class="display-4 mr-3" />

          <span class="">
            <label class="form-label">Pessoa Jurídica</label><br />
            {{ legal_person.fantasy_name }}
            <small class="d-block">{{ legal_person.social_reason }}</small>
          </span>
        </h4>
      </div>

      <div class="col-2 d-flex align-items-end">
        <router-link
          v-if="$can('legal_people:edit')"
          :to="{
            name: 'legal_people_edit',
            params: { id: legal_person.id }
          }"
          class="btn btn-outline-primary mr-2 link-edit"
          >Editar</router-link
        >

        <router-link
          v-else
          :to="{
            name: 'legal_people_show',
            params: { id: legal_person.id }
          }"
          class="btn btn-outline-primary mr-2 link-edit d-none"
          >Visualizar</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("legal_people", ["legal_person"])
  },
  methods: {},
  async created() {}
};
</script>
